import { useMemo } from 'react';
import { useMutation } from '@apollo/client';
import { v4 as uuid } from 'uuid';
import useSnackBars from './useSnackBars';

const useDocumentFetchMutation = (mutation, companyId) => {
  const { addAlert } = useSnackBars();
  const [fetchDocument, { data, error, loading }] = useMutation(mutation, {
    variables: { companyId },
    notifyOnNetworkStatusChange: true,
    onCompleted: (result) => {
      const payload = result ? Object.values(result)[0] : null;
      if (!payload?.severity) return;
      addAlert({
        id: `document-fetch-${companyId}-${payload.severity}-${uuid()}`,
        severity: payload.severity || 'info',
        message: payload.message,
      });
    },
  });
  const fetchResult = useMemo(() => (data ? Object.values(data)[0] : null), [data]);
  return { fetchDocument, data, error, loading, fetchResult };
};

export default useDocumentFetchMutation;
